import { LOCALE_ID, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CoreCommonModule } from "@core/common.module";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { LoginComponent } from "./auth/login/login.component";
import { MainComponent } from "./dashboard/main/main.component";
import { AuthGuard } from "../auth/helpers";
import { LogoutComponent } from "./auth/logout/logout.component";
import { NgbDatepickerModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserModule } from "@angular/platform-browser";
import { CoreCardModule } from "../../@core/components/core-card/core-card.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { LayoutModule } from "../layout/layout.module";
import { CapabilityListComponent } from "./dashboard/capability/list/capability-list.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CapabilityFormComponent } from "./dashboard/capability/form/capability-form.component";
import { CapabilityAssignComponent } from "./dashboard/capability/assign/capability-assign.component";
import { UserListComponent } from "./dashboard/user/list/user-list.component";
import { UserProfileComponent } from "./dashboard/user/profile/user-profile.component";
import { UserFormEditComponent } from "./dashboard/user/form-edit/user-form-edit.component";
import { UserFormAddComponent } from "./dashboard/user/form-add/user-form-add.component";
import { UserProfileDocumentsComponent } from "./dashboard/user/profile-documents/user-profile-documents.component";
import { BlockUIModule } from "ng-block-ui";
import { NgApexchartsModule } from "ng-apexcharts";
import { UserCurriculumComponent } from "./dashboard/user/profile-curriculum/user-curriculum.component";
import { GestioneCostiContrattiComponent } from "./dashboard/gestione-dati/costi-contratti/modifica/gestione-costi-contratti.component";
import { ListaCostiContrattiComponent } from "./dashboard/gestione-dati/costi-contratti/lista/lista-costi-contratti.component";
import { OnboardingAnagraficaComponent } from "./onboarding/masterdata/onboarding-anagrafica.component";
import { OnboardingCvExperienceComponent } from "./onboarding/experiences/onboarding-cv-experience.component";
import { OnboardingSkillsFormComponent } from "./onboarding/skills/onboarding-skills-form.component";
import { OnboardingCertificationsComponent } from "./onboarding/certifications/onboarding-certifications.component";
import { OnboardingLanguagesComponent } from "./onboarding/languages/onboarding-languages.component";
import { LandingInsertDataComponent } from "./landing/request-masterdata/landing-insert-data.component";
import { SignContractComponent } from "./landing/sign-contract/sign-contract.component";
import { SkillsListComponent } from "./dashboard/skills/list/skills-list.component";
import { CitiesListComponent } from "./dashboard/cities/list/cities-list.component";
import { CitiesFormComponent } from "./dashboard/cities/form/cities-form.component";
import { SourcesListComponent } from "../modules/recruitment/candidates/pages/candidate-sources-list/sources-list.component";
import { FiguresListComponent } from "./dashboard/figures/figures-list/figures-list.component";
import { ListEducationTitleComponent } from "./dashboard/education/list-education-title/list-education-title.component";
import { ListEducationSubjectComponent } from "./dashboard/education/list-education-subject/list-education-subject.component";
import { RolesListComponent } from "./dashboard/capability/roles-list/roles-list.component";
import { ListCertificationsComponent } from "./dashboard/education/list-certifications/list-certifications.component";
import { GroupsListComponent } from "./dashboard/groups/list/groups-list.component";
import { GroupsFormComponent } from "./dashboard/groups/form/groups-form.component";
import { AbsencesTypeListComponent } from "./dashboard/absences/types/list/absences-type-list.component";
import { AbsencesTypeFormComponent } from "./dashboard/absences/types/form/absences-type-form.component";
import { NotificationListComponent } from "./dashboard/notification/list/list-notifications.component";
import { NotificationCategoriesListComponent } from "./dashboard/notification/categories/categories-list.component";
import { FormCommunicationComponent } from "./dashboard/communications/form/form-communication.component";
import { AbsenceRequestedListComponent } from "./dashboard/absences/absence-requested-list/absence-requested-list.component";
import { AbsenceUserListComponent } from "./dashboard/absences/absence-user-list/absence-user-list.component";
import { NotificationUserListComponent } from "./dashboard/notification/user-list/notification-user-list.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { RefundsRequestedListComponent } from "./dashboard/refunds/requested-list/refunds-requested-list.component";
import { RefundsUserListComponent } from "./dashboard/refunds/user-list/refunds-user-list.component";
import { DocumentsCategoriesComponent } from "./dashboard/documents/staff/staff-documents-categories/documents-categories.component";
import { DocumentsSendComponent } from "./dashboard/documents/staff/staff-documents-send/documents-send.component";
import { DocumentPreviewComponent } from "./dashboard/documents/staff/staff-documents-send/document-preview/document-preview.component";
import { DocumentsMyDocumentsComponent } from "./dashboard/documents/user-my-documents/documents-my-documents.component";
import { StaffAllDocumentsListComponent } from "./dashboard/documents/staff/staff-all-documents-list/staff-all-documents-list.component";
import { UserSingleDocumentViewComponent } from "./dashboard/documents/user-single-document-view/user-single-document-view.component";
import { SingleDocumentComponent } from "./dashboard/documents/staff/staff-single-document/single-document.component";
import { StaffDocumentEditComponent } from "./dashboard/documents/staff/staff-document-edit/staff-document-edit.component";
import { customBreakPointsProvider } from "../layout/custom-breakpoints";
import { StaffSingleDocumentFileComponent } from "./dashboard/documents/staff/staff-single-document-file/staff-single-document-file.component";
import { ReplaceFieldListComponent } from "./dashboard/documents/staff/staff-documents-send/replace-field-list/replace-field-list.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { BreadcrumbModule } from "../layout/components/content-header/breadcrumb/breadcrumb.module";
import { ChangePasswordComponent } from "./landing/change-password/change-password.component";
import { ResidualAbsencesListComponent } from "./dashboard/absences/residual-absences/residual-absences-list/residual-absences-list.component";
import { ResidualAbsencesEditComponent } from "./dashboard/absences/residual-absences/residual-absences-edit/residual-absences-edit.component";
import { ContractListComponent } from "./dashboard/contract/contract-list/contract-list.component";
import { AngularFileUploaderModule } from "angular-file-uploader";
import { DomainListComponent } from "./dashboard/domain/domain-list/domain-list.component";
import { FutureEmployeesComponent } from "./dashboard/user/future-employees/list/future-employees.component";
import { PlatformManagementComponent } from "./dashboard/platform-management/platform-management.component";
import { ConfigurationsComponent } from "./dashboard/configurations/configurations.component";
import { ConfigurationReportUnlockDayComponent } from "./dashboard/configurations/report-unlock-day/configuration-report-unlock-day.component";
import { PayrollListComponent } from "./dashboard/payroll/list/payroll-list.component";
import { EditManagerContractComponent } from "./dashboard/manager-contract/edit/edit-manager-contract.component";
import { ListManagerContractComponent } from "./dashboard/manager-contract/list/list-manager-contract.component";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { FormTemplateComponent } from "./dashboard/documents-template/form-template/form-template.component";
import { TemplateListComponent } from "./dashboard/documents-template/template-list/template-list.component";
import { TemplateDocumentToUserComponent } from "./dashboard/documents-template/template-document-to-user/template-document-to-user.component";
import { IbanComponent } from "./onboarding/iban/iban.component";
import { DocumentalComponent } from "./onboarding/documental/documental.component";
import { TutorialListComponent } from "./dashboard/tutorial/tutorial-list/tutorial-list.component";
import { TutorialListForUserComponent } from "./dashboard/tutorial/tutorial-list-for-user/tutorial-list-for-user.component";
import { TranslateDbListComponent } from "./dashboard/translate-db/translate-db-list/translate-db-list.component";
import { RefundsKilometersComponent } from "./dashboard/refunds/refunds-kilometers/refunds-kilometers.component";
import { MiscellaneousModule } from "./miscellaneous/miscellaneous.module";
import { DealsListComponent } from "./dashboard/deals/deals-list/deals-list.component";
import { DealsCreateComponent } from "./dashboard/deals/deals-create/deals-create.component";
import { DealsEditComponent } from "./dashboard/deals/deals-edit/deals-edit.component";
import { DealsTemplatesParagraphsComponent } from "./dashboard/deals/deals-templates-paragraphs/deals-templates-paragraphs.component";
import { ShortLinkComponent } from "./dashboard/short-link/short-link.component";
import { DetailShortLinkComponent } from "./dashboard/short-link/detail-short-link/detail-short-link.component";
import { OrdersListComponent } from "./dashboard/orders/orders-list/orders-list.component";
import { CommissionListComponent } from "./dashboard/commission/commission-list/commission-list.component";
import { CommissionCreateComponent } from "./dashboard/commission/commission-create/commission-create.component";
import { CommissionEditComponent } from "./dashboard/commission/commission-edit/commission-edit.component";
import { PaymentTermsListComponent } from "./dashboard/payment-terms/payment-terms-list/payment-terms-list.component";
import { BillingFrequencyListComponent } from "./dashboard/billing-frequency/billing-frequency-list/billing-frequency-list.component";
import { AddressBookComponent } from "./dashboard/user/address-book/address-book.component";
import { PaymentMeasureUnitComponent } from "./dashboard/payment-measure-unit/payment-measure-unit.component";
import { CausalListComponent } from "./dashboard/causal/causal-list.component";
import { ResignedEmployeesComponent } from "./dashboard/user/resigned-employees/resigned-employees.component";
import { registerLocaleData } from "@angular/common";
import localeIt from "@angular/common/locales/it";
import localeItExtra from "@angular/common/locales/extra/it";
import { ExEmployeesListComponent } from "./dashboard/user/ex-employees-list/ex-employees-list.component";
import { ContractListForTypeComponent } from "./dashboard/gestione-dati/costi-contratti/contract-list-for-type/contract-list-for-type.component";
import { FutureEmployeeProfileComponent } from "./dashboard/user/future-employees/profile/future-employee-profile.component";
import { CommissionStats } from "./dashboard/commission/commission-stats/commission-stats.component";
import { AnalyticsComponent } from "./dashboard/analytics/analytics.component";
import { IRoute } from "app/auth/models/utils-interfaces";
import { SendMultipleWelcomeEmailComponent } from "./dashboard/user/send-multiple-welcome-email/send-multiple-welcome-email.component";
import { DealsDuplicateComponent } from "./dashboard/deals/deals-duplicate/deals-duplicate.component";
import { AssetsModule } from "../modules/assets/assets.module";
import { EconomicGraphComponent } from "./dashboard/commission/components/economic-graph/economic-graph.component";
import { PlanningListComponent } from "./dashboard/user/planning-list/planning-list.component";
import { CustomerModule } from "../modules/customer/customer.module";
import { UserEconomicGraphComponent } from './dashboard/user/user-economic-graph/user-economic-graph.component';
import { EconomicsBalanceComponent } from './dashboard/economics-balance/economics-balance.component';

registerLocaleData(localeIt, "it", localeItExtra);

const routes: IRoute[] = [
  {
    path: "auth/login",
    component: LoginComponent,
    data: { animation: "auth" },
  },
  {
    path: "auth/logout",
    component: LogoutComponent,
  },
  {
    path: "dashboard/main",
    canActivate: [AuthGuard],
    component: MainComponent,
    data: { animation: "ecommerce" },
  },
  {
    path: "dashboard/education-titles",
    canActivate: [AuthGuard],
    component: ListEducationTitleComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/analytics",
    canActivate: [AuthGuard],
    component: AnalyticsComponent,
    data: { animation: "analytics" },
  },
  {
    path: "dashboard/education-subject",
    canActivate: [AuthGuard],
    component: ListEducationSubjectComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/certifications",
    canActivate: [AuthGuard],
    component: ListCertificationsComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/capability/list",
    canActivate: [AuthGuard],
    component: CapabilityListComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/capability/add",
    canActivate: [AuthGuard],
    component: CapabilityFormComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/capability/edit/:id",
    canActivate: [AuthGuard],
    component: CapabilityFormComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/capability/assign",
    canActivate: [AuthGuard],
    component: CapabilityAssignComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/roles",
    canActivate: [AuthGuard],
    component: RolesListComponent,
    data: { animation: "decommerce" },
  },
  {
    path: "dashboard/user",
    component: UserListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/list",
    component: UserListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/list/:user_type",
    component: UserListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/profile",
    component: UserProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/profile/:user_identifier",
    component: UserProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/future-employee/profile/:user_identifier",
    component: FutureEmployeeProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/profile/:user_identifier/documents",
    component: UserProfileDocumentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/profile/:user_identifier/curriculum",
    component: UserCurriculumComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/add/:user_type",
    component: UserFormAddComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/user/edit/:user_identifier",
    component: UserFormEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/skills",
    component: SkillsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/cities",
    component: CitiesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/cities/add",
    component: CitiesFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/cities/edit/:id",
    component: CitiesFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/figures",
    component: FiguresListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "onboarding",
    canActivate: [AuthGuard],
    component: OnboardingAnagraficaComponent,
  },
  {
    path: "onboarding/masterdata",
    canActivate: [AuthGuard],
    component: OnboardingAnagraficaComponent,
  },
  {
    path: "onboarding/education",
    canActivate: [AuthGuard],
    component: OnboardingCertificationsComponent,
  },
  {
    path: "onboarding/experiences",
    canActivate: [AuthGuard],
    component: OnboardingCvExperienceComponent,
  },
  {
    path: "onboarding/skills",
    canActivate: [AuthGuard],
    component: OnboardingSkillsFormComponent,
  },
  {
    path: "onboarding/languages",
    canActivate: [AuthGuard],
    component: OnboardingLanguagesComponent,
  },
  {
    path: "onboarding/iban",
    canActivate: [AuthGuard],
    component: IbanComponent,
  },
  {
    path: "onboarding/documents",
    canActivate: [AuthGuard],
    component: DocumentalComponent,
  },
  {
    path: "landing/request-masterdata",
    component: LandingInsertDataComponent,
  },
  {
    path: "landing/sign-contract",
    component: SignContractComponent,
    capability: "view_contracts_costs",
  },
  {
    path: "dashboard/gestione/costi-contratti",
    component: GestioneCostiContrattiComponent,
    canActivate: [AuthGuard],
    capability: "manage_contracts_costs",
  },
  {
    path: "dashboard/gestione/costi-contratti/list",
    component: ListaCostiContrattiComponent,
    canActivate: [AuthGuard],
    capability: "view_contracts_costs",
  },
  {
    path: "dashboard/gestione/costi-contratti/detailed-list",
    component: ContractListForTypeComponent,
    canActivate: [AuthGuard],
    capability: "view_contracts_costs",
  },
  {
    path: "dashboard/gestione/costi-contratti/edit",
    component: GestioneCostiContrattiComponent,
    canActivate: [AuthGuard],
    capability: "manage_contracts_costs",
  },
  {
    path: "dashboard/groups",
    component: GroupsListComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
  },
  {
    path: "dashboard/groups/add",
    component: GroupsFormComponent,
    canActivate: [AuthGuard],
    capability: "add_group",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/groups/edit/:group_id",
    component: GroupsFormComponent,
    canActivate: [AuthGuard],
    capability: "edit_group",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/absences-type-list",
    component: AbsencesTypeListComponent,
    canActivate: [AuthGuard],
    capability: "edit_group",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/absence/add",
    component: AbsencesTypeFormComponent,
    canActivate: [AuthGuard],
    capability: "edit_group",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/absence/edit/:id",
    component: AbsencesTypeFormComponent,
    canActivate: [AuthGuard],
    capability: "edit_group",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/communications-list",
    component: NotificationListComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/category-communications",
    component: NotificationCategoriesListComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/send-communication",
    component: FormCommunicationComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/edit-communication/:id",
    component: FormCommunicationComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/absence/requested-list",
    component: AbsenceRequestedListComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/absence/list-user",
    component: AbsenceUserListComponent,
    canActivate: [AuthGuard],
    capability: "show_list_groups",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/notifications",
    component: NotificationUserListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_user_notifications",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/refunds/requested",
    component: RefundsRequestedListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_requested_refunds",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/my-refunds",
    component: RefundsUserListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_user_refund_list",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/documents-categories",
    component: DocumentsCategoriesComponent,
    canActivate: [AuthGuard],
    capability: "show_categories_documents",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/documents-send",
    component: DocumentsSendComponent,
    canActivate: [AuthGuard],
    capability: "create_document",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/documents-preview",
    component: DocumentPreviewComponent,
    canActivate: [AuthGuard],
    capability: "create_document",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/my-documents",
    component: DocumentsMyDocumentsComponent,
    canActivate: [AuthGuard],
    data: { animation: "flatpickr" },
  },

  {
    path: "dashboard/documents-list",
    component: StaffAllDocumentsListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_documents_list",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/user-document-view/:id",
    component: UserSingleDocumentViewComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },

  {
    path: "dashboard/document-staff-view/:id",
    component: SingleDocumentComponent,
    canActivate: [AuthGuard],
    data: { animation: "flatpickr" },
  },

  {
    path: "dashboard/document-edit/:id",
    component: StaffDocumentEditComponent,
    canActivate: [AuthGuard],
    capability: "edit_document",
    data: { animation: "flatpickr" },
  },

  {
    path: "dashboard/single-document-file/:id",
    component: StaffSingleDocumentFileComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
  // lista-contratti
  {
    path: "dashboard/contract-list",
    component: ContractListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_contract_list",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/planning-list",
    component: PlanningListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_planning_list",
    data: { animation: "flatpickr" },
  },
  // lista buste paga
  {
    path: "dashboard/payroll",
    component: PayrollListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_payroll",
    data: { animation: "flatpickr" },
  },
  {
    path: "landing/create-password",
    component: ChangePasswordComponent,
  },
  {
    path: "landing/reset-password",
    component: ChangePasswordComponent,
  },
  {
    path: "dashboard/list-residual-absences",
    component: ResidualAbsencesListComponent,
    canActivate: [AuthGuard],
    capability: "view_residual_absences_list",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/edit-residual-absences",
    component: ResidualAbsencesEditComponent,
    canActivate: [AuthGuard],
    capability: "update_residual_absences_list",
    data: { animation: "flatpickr" },
  },
  // Settori merceologici
  {
    path: "dashboard/domain-list",
    component: DomainListComponent,
    canActivate: [AuthGuard],
    capability: "view_domain_list",
    data: { animation: "flatpickr" },
  },
  // dipendenti futuri
  {
    path: "dashboard/user/future-employees",
    component: FutureEmployeesComponent,
    canActivate: [AuthGuard],
    capability: "view_future_employees",
    data: { animation: "flatpickr" },
  },
  // dipendenti dimissionari
  {
    path: "dashboard/user/resigned-employees",
    component: ResignedEmployeesComponent,
    canActivate: [AuthGuard],
    capability: "view_resigned_employees",
    data: { animation: "flatpickr" },
  },
  // gestione
  {
    path: "dashboard/platform-management",
    component: PlatformManagementComponent,
    canActivate: [AuthGuard],
    capability: "view_future_employees",
  },
  // opzioni
  {
    path: "dashboard/configurations",
    component: ConfigurationsComponent,
    canActivate: [AuthGuard],
  },
  // opzioni
  {
    path: "dashboard/configurations/report-unlock-day",
    component: ConfigurationReportUnlockDayComponent,
    canActivate: [AuthGuard],
    capability: "manage_report_unlock_day",
  },
  // lista template contratti
  {
    path: "dashboard/manager-contract",
    component: ListManagerContractComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_manager_contract",
  },
  {
    path: "dashboard/manager-contract/edit/:type",
    component: EditManagerContractComponent,
    canActivate: [AuthGuard],
    capability: "edit_manager_contract",
  },
  //template documenti form
  {
    path: "dashboard/documents-form-template",
    component: FormTemplateComponent,
    canActivate: [AuthGuard],
  },
  //template documenti form
  {
    path: "dashboard/documents-form-template/:id",
    component: FormTemplateComponent,
    canActivate: [AuthGuard],
  },
  //template documenti list
  {
    path: "dashboard/documents-list-template",
    component: TemplateListComponent,
    canActivate: [AuthGuard],
  },
  //Lista utenti(per ogni utente si visualizza un template)
  {
    path: "dashboard/documents/document-to-user",
    component: TemplateDocumentToUserComponent,
    canActivate: [AuthGuard],
  },
  //tutorial-lista
  {
    path: "dashboard/tutorial-list",
    component: TutorialListComponent,
    canActivate: [AuthGuard],
    capability: "view_tutorial_list",
  },
  //tutorial lista per gli utenti
  {
    path: "dashboard/tutorials",
    component: TutorialListForUserComponent,
    canActivate: [AuthGuard],
  },
  //lista campi db
  {
    path: "dashboard/fields-db-list",
    component: TranslateDbListComponent,
    canActivate: [AuthGuard],
    capability: "show_field_database_list",
  },
  //Lista utenti con i rimborsi da pagare
  {
    path: "dashboard/refunds/user-list-refund",
    component: RefundsKilometersComponent,
    canActivate: [AuthGuard],
  },
  //Deals list
  {
    path: "dashboard/deals/list",
    component: DealsListComponent,
    canActivate: [AuthGuard],
  },
  //Create deal
  {
    path: "dashboard/deals/create",
    component: DealsCreateComponent,
    canActivate: [AuthGuard],
  },
  //Edit deal
  {
    path: "dashboard/deals/edit/:id",
    component: DealsEditComponent,
    canActivate: [AuthGuard],
  },
  //Duplicate deal
  {
    path: "dashboard/deals/duplicate/:id",
    component: DealsDuplicateComponent,
    canActivate: [AuthGuard],
  },
  //Edit deals templates paragraphs
  {
    path: "dashboard/deals/edit-template-paragraphs",
    component: DealsTemplatesParagraphsComponent,
    canActivate: [AuthGuard],
  },
  //short links
  {
    path: "dashboard/short-links",
    component: ShortLinkComponent,
    canActivate: [AuthGuard],
    capability: "view_shortlink_list",
  },
  // dettaglio short links
  {
    path: "dashboard/short-links/detail/:id",
    component: DetailShortLinkComponent,
    canActivate: [AuthGuard],
    capability: "view_shortlink_detail",
  },
  //Commission list
  {
    path: "dashboard/commission/list",
    component: CommissionListComponent,
    canActivate: [AuthGuard],
  },
  //Commission create
  {
    path: "dashboard/commission/create",
    component: CommissionCreateComponent,
    canActivate: [AuthGuard],
  },
  //Commission edit
  {
    path: "dashboard/commission/edit/:id",
    component: CommissionEditComponent,
    canActivate: [AuthGuard],
  },
  //Orders list
  {
    path: "dashboard/orders/list",
    component: OrdersListComponent,
    canActivate: [AuthGuard],
  },
  //Payment terms list
  {
    path: "dashboard/payment-terms",
    component: PaymentTermsListComponent,
    canActivate: [AuthGuard],
  },
  //Billing frequencies
  {
    path: "dashboard/billing-frequency",
    component: BillingFrequencyListComponent,
    canActivate: [AuthGuard],
  },
  // rubrica
  {
    path: "dashboard/address-book",
    component: AddressBookComponent,
    canActivate: [AuthGuard],
  },
  // commesse
  {
    path: "dashboard/commission/analytics",
    component: CommissionStats,
    canActivate: [AuthGuard],
  },

  //Invoices types list
  {
    path: "dashboard/payment-measure-unit",
    component: PaymentMeasureUnitComponent,
    canActivate: [AuthGuard],
  },

  //Causals list
  {
    path: "dashboard/causals",
    component: CausalListComponent,
    canActivate: [AuthGuard],
  },

  //Causals list
  {
    path: "dashboard/capability/roles",
    component: RolesListComponent,
    canActivate: [AuthGuard],
  },
  //Causals list
  {
    path: "dashboard/send-multiple-welcome-email",
    component: SendMultipleWelcomeEmailComponent,
    canActivate: [AuthGuard],
  },
  //Economics balance
  {
    path: "dashboard/economic-balance",
    component: EconomicsBalanceComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    LoginComponent,
    CapabilityListComponent,
    CapabilityFormComponent,
    CapabilityAssignComponent,
    UserListComponent,
    UserProfileComponent,
    UserFormEditComponent,
    UserFormAddComponent,
    UserCurriculumComponent,
    GestioneCostiContrattiComponent,
    ListaCostiContrattiComponent,
    OnboardingAnagraficaComponent,
    OnboardingCvExperienceComponent,
    OnboardingSkillsFormComponent,
    OnboardingCertificationsComponent,
    OnboardingLanguagesComponent,
    LandingInsertDataComponent,
    SignContractComponent,
    OnboardingLanguagesComponent,
    SkillsListComponent,
    CitiesListComponent,
    CitiesFormComponent,
    SourcesListComponent,
    FiguresListComponent,
    ListEducationTitleComponent,
    ListEducationSubjectComponent,
    RolesListComponent,
    ListCertificationsComponent,
    GroupsListComponent,
    GroupsFormComponent,
    AbsencesTypeListComponent,
    AbsencesTypeFormComponent,
    NotificationListComponent,
    NotificationCategoriesListComponent,
    FormCommunicationComponent,
    AbsenceRequestedListComponent,
    AbsenceUserListComponent,
    NotificationUserListComponent,
    RefundsUserListComponent,
    RefundsRequestedListComponent,
    DocumentsCategoriesComponent,
    DocumentsSendComponent,
    DocumentPreviewComponent,
    DocumentsMyDocumentsComponent,
    StaffAllDocumentsListComponent,
    UserSingleDocumentViewComponent,
    SingleDocumentComponent,
    StaffDocumentEditComponent,
    StaffSingleDocumentFileComponent,
    ReplaceFieldListComponent,
    ChangePasswordComponent,
    ResidualAbsencesListComponent,
    ResidualAbsencesEditComponent,
    ContractListComponent,
    PayrollListComponent,
    DomainListComponent,
    FutureEmployeesComponent,
    PlatformManagementComponent,
    ConfigurationReportUnlockDayComponent,
    ConfigurationsComponent,
    EditManagerContractComponent,
    ListManagerContractComponent,
    FormTemplateComponent,
    TemplateListComponent,
    TemplateDocumentToUserComponent,
    IbanComponent,
    DocumentalComponent,
    TutorialListComponent,
    TutorialListForUserComponent,
    TranslateDbListComponent,
    RefundsKilometersComponent,
    ShortLinkComponent,
    DetailShortLinkComponent,
    DealsListComponent,
    DealsCreateComponent,
    DealsEditComponent,
    DealsTemplatesParagraphsComponent,
    ShortLinkComponent,
    OrdersListComponent,
    CommissionListComponent,
    CommissionCreateComponent,
    CommissionEditComponent,
    PaymentTermsListComponent,
    AddressBookComponent,
    BillingFrequencyListComponent,
    AddressBookComponent,
    PaymentMeasureUnitComponent,
    CausalListComponent,
    ResignedEmployeesComponent,
    ExEmployeesListComponent,
    ContractListForTypeComponent,
    FutureEmployeeProfileComponent,
    CommissionStats,
    AnalyticsComponent,
    SendMultipleWelcomeEmailComponent,
    DealsDuplicateComponent,
    EconomicGraphComponent,
    PlanningListComponent,
    UserEconomicGraphComponent,
    EconomicsBalanceComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forChild(routes),
    ContentHeaderModule,
    NgbModule,
    TranslateModule,
    CoreCommonModule,
    CoreCardModule,
    NgSelectModule,
    Ng2FlatpickrModule,
    MiscellaneousModule,
    LayoutModule,
    NgxDatatableModule,
    BlockUIModule,
    NgApexchartsModule,
    AngularEditorModule,
    DragDropModule,
    BreadcrumbModule,
    AngularFileUploaderModule,
    NgbDatepickerModule,
    PerfectScrollbarModule,
    AssetsModule,
    CustomerModule,
  ],
  exports: [LoginComponent, ResignedEmployeesComponent],
  providers: [customBreakPointsProvider, { provide: LOCALE_ID, useValue: "it-IT" }],
})
export class DashboardPagesModule {}
